<template>
  <v-app>
    <v-progress-linear
      v-if="isLoading"
      indeterminate
      color="primary darken-2"
    ></v-progress-linear>
    <v-main>
      <router-view />
    </v-main>
    <Ribbon />
    <Modal2FA />
  </v-app>
</template>

<script>
import { mapState } from 'vuex'
import Ribbon from '@/components/Ribbon.vue'
import Modal2FA from '@/components/Modal2FA.vue'

export default {
  name: 'App',

  computed: {
    ...mapState({
      isLoading: (state) => state.loading?.isLoading,
    }),
  },

  data: () => ({
    //
  }),

  components: { Ribbon, Modal2FA },
}
</script>

<style lang="stylus" scoped>
::v-deep .v-application--wrap
  z-index: 0
</style>
